import { useEffect, useState } from 'react';
import VipTierCard, {
  TIER_ORDER,
  type Tier,
} from '@/components/feature/VipTierCard';
import useScrollReveal from '@/hooks/useScrollReveal';
import { useLanguage } from '@/localization';

interface StripeTier {
  name: string;
  prices: { amount: number; months: number }[];
}

export default function VipSection() {
  const sectionRef = useScrollReveal();
  const { t } = useLanguage();
  const [tiers, setTiers] = useState<Partial<Record<Tier, StripeTier>>>({});

  useEffect(() => {
    fetch('/map-api/stripe/prices')
      .then((response) => response.json())
      .then((data) => {
        if (!data.error && data.checkoutEnabled) setTiers(data);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="vip" ref={sectionRef} className="py-24 relative">
      <div className="container mx-auto px-4 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-orbitron horror-heading">
            {t('Support Our')}{' '}
            <span className="text-red-500">{t('Server')}</span>
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6" />
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t(
              'Help keep our server running and get exclusive benefits with our VIP membership tiers',
            )}
          </p>
        </div>

        {/* Pricing cards */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-10 max-w-4xl mx-auto items-stretch">
          {TIER_ORDER.map((tier, index) => {
            const data = tiers[tier];
            const monthlyPrice =
              data?.prices.find((p) => p.months === 1)?.amount ?? null;

            return (
              <div
                key={tier}
                className="scroll-reveal"
                style={{ animationDelay: `${(index + 1) * 0.15}s` }}
              >
                <VipTierCard
                  tier={tier}
                  name={data?.name ?? (tier === 'vip_plus' ? 'VIP+' : 'VIP')}
                  monthlyPrice={monthlyPrice}
                  glowPersistent={tier === 'vip_plus'}
                  ctaHref={`/vip?tier=${tier}`}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
